import { Component, OnInit } from '@angular/core';
import { Authentication } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-not-logged-in',
  templateUrl: './not-logged-in.component.html',
  styleUrls: ['./not-logged-in.component.css'],
})
export class NotLoggedInComponent implements OnInit {
  constructor(
    private authService: Authentication,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
  ) {
    if (this.authService.isTokenValid()) {
      this.router.navigate(['dashboard']);
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.activatedRoute.snapshot, this.router.routerState.snapshot);
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com';
  }
}
